import { backHome, primaryAction, selectAnswer, skipQuestion } from "./quizState"
import { rerender } from "./render"
import { buildRef } from "./selection"
import { state } from "./state"
import { isBookmarked, toggleBookmark } from "./storage"
import { letterFor, modeLabel, pad } from "./util"

export function Quiz() {
  if (state.queue.length === 0) return null

  const qIdx = state.queue[0]
  const q = state.allQuestions[qIdx]
  const total = state.allQuestions.length
  const answered = Object.keys(state.results).length
  const options = state.shuffledChoices[qIdx] ?? []
  const correctIdx = options.indexOf(q.answer.text)
  const hasSelection = qIdx in state.selections
  const priorSelection = state.selections[qIdx]
  const r = buildRef(q)
  const bookmarked = isBookmarked(q)

  return (
    <>
      <div class="progress-bar">
        <span>
          Answered {pad(answered)} / {pad(total)}
        </span>
        <span class="progress-right">
          <span class="returned-pill" style={{ display: state.wasSkipped[qIdx] ? "inline-flex" : "none" }}>
            Returned
          </span>
          <span>{modeLabel(state.currentMode, state.currentSection)}</span>
        </span>
      </div>
      <div class="progress-fill-bg">
        <div class="progress-fill" style={{ width: `${(answered / total) * 100}%` }} />
      </div>

      <h2 class="question-text">{q.q}</h2>

      <div class="answers">
        {options.map((opt, i) => {
          const isSelected = !state.confirmed && priorSelection === i
          const isCorrect = state.confirmed && i === correctIdx
          const isWrong = state.confirmed && i === priorSelection && i !== correctIdx
          return (
            <button
              key={i}
              type="button"
              class={`answer-btn${isSelected ? " selected" : ""}${isCorrect ? " correct" : ""}${isWrong ? " incorrect" : ""}`}
              disabled={state.confirmed}
              onClick={() => selectAnswer(i)}
            >
              <span class="answer-letter">{letterFor(i)}</span>
              <span class="answer-text">{opt}</span>
              <span class="answer-status">{isCorrect ? "✓ Correct" : isWrong ? "✗ Wrong" : ""}</span>
            </button>
          )
        })}
      </div>

      <div class={`feedback${state.confirmed ? " show" : ""}`}>
        <div class="feedback-label">Handbook Reference</div>
        <div class="ref-grid">
          <div class="ref-col ref-col-section">
            <div class="ref-num">Section {r.section}</div>
            <div class="ref-title">{r.topic}</div>
          </div>
          <div class="ref-col ref-col-page">
            <div class="ref-num">Page {r.page}</div>
            <button
              type="button"
              class={`bookmark-btn${bookmarked ? " active" : ""}`}
              onClick={() => {
                toggleBookmark(q)
                rerender()
              }}
            >
              {bookmarked ? "Bookmarked" : "Bookmark"}
            </button>
          </div>
        </div>
      </div>

      <div class="quiz-actions">
        <button type="button" class="btn ghost" onClick={backHome}>
          ← Home
        </button>
        <div class="action-group">
          {!state.confirmed && (
            <button type="button" class="btn" disabled={state.queue.length <= 1} onClick={skipQuestion}>
              Skip →
            </button>
          )}
          <button
            type="button"
            class="btn primary"
            disabled={!state.confirmed && !hasSelection}
            onClick={primaryAction}
          >
            {state.confirmed ? (state.queue.length === 1 ? "Finish →" : "Next →") : "Confirm Answer"}
          </button>
        </div>
      </div>
    </>
  )
}
